import React from 'react';
import { useSelector } from 'react-redux';
import Chip from '@material-ui/core/Chip';

const CodePromoFilter = props => {
  const discountCodes = useSelector(state => state.search?.discountCodes);

  if (Array.isArray(discountCodes) && discountCodes.length > 0) {
    return (
      <div style={{ display: 'inline' }} {...props}>
        <Chip
          label={`Code : ${discountCodes[0]}`}
          color="primary"
          variant="outlined"
        />
      </div>
    );
  }

  return null;
};

export default CodePromoFilter;
